export enum ErrorCode {
  UnableToReachServer = "UnableToReachServer",
  UnknownError = "UnknownError",
}
